import { MAX_CONSOLIDATION_BIN_BATCH } from "@redotech/redo-return-warehouse-processing-common/merchant-consolidation-bin";
import { merchantConsolidationBinIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";

export const deleteConsolidationBins = {
  name: "deleteConsolidationBins" as const,
  input: z.object({
    merchantConsolidationBinIds: z
      .array(merchantConsolidationBinIdFormat.schema)
      .min(1)
      .max(MAX_CONSOLIDATION_BIN_BATCH),
  }),
  output: z.object({}),
};
